<template>
  <f-dashboard-content-layout>
    <template #dashboard-content-side>
      <f-dashboard-content-nav
        v-for="currentNav in currentNavs" 
        :key="currentNav.title"
        :links="currentNav.links"
      >
        <template #title>
          <h6>
            <i :class="currentNav.icon"></i>
            <small>{{ currentNav.title }}</small>
          </h6>
        </template>
      </f-dashboard-content-nav>
    </template>

    <router-view></router-view>
  </f-dashboard-content-layout>
</template>

<script>
  import { computed, watch } from 'vue'
  import { useStore } from '@freebe/sdk/store'
  import useRoles from '@composables/use-roles'
  import router from '@core/router'
  
  export default {
    setup () {
      const { checkPermissions } = useRoles()

      if (!checkPermissions('users:find') && !checkPermissions('roles:find')) {
        router.push({ name: 'home' })
      }

      const userId = computed(() => router.currentRoute.value.params.id)

      const adminNavs = [{
        title: 'Admin',
        icon: 'uil uil-user',
        links: [{
          name: 'Profil',
          to: { 
            name: 'admin-profile',
            params: {
              id: userId.value,
            }
          }
          }, {
          name: 'Permissions',
          to: { 
            name: 'admin-permissions',
            params: {
              id: userId.value,
            }
          }
          }, {
          name: 'Historique',
          to: { 
            name: 'admin-history',
            params: {
              id: userId.value,
            }
          } 
        }]
      }]

      const listNavs = [{
        title: 'Users',
        icon: 'uil uil-user',
        links: [{
          name: 'Admins',
          to: { 
            name: 'admins-list',
          },
          exact: true,
        }]
      }, {
        title: 'Rôles & permissions',
        icon: 'uil uil-lock',
        links: [{
          name: 'Rôles',
          to: { 
            name: 'roles-list',
          },
        }]
      }]

      const currentNavs = computed(() => {
        return userId.value ? adminNavs : listNavs
      })

      return {
        currentNavs,
      }
    },
  }
</script>
